// extracted by mini-css-extract-plugin
export default {"loader":"zyV1i2pGCP27tjUaozTt"};